import { createAction } from 'redux-act'
import { SET_COUNT, INCREMENT_COUNT, DECREMENT_COUNT } from './action-types'

export const setCountTransport = createAction<number | undefined>(SET_COUNT)
export const incrementCountTransport = createAction(INCREMENT_COUNT)
export const decrementCountTransport = createAction(DECREMENT_COUNT)
